import { Details as BaseDetails } from "@tiptap-pro/extension-details";

export const Details = BaseDetails.configure({ persist: true });
